module.exports = __webpack_public_path__ + "img/logo_yotpo.04ed57ba.png";